import React from 'react'
import { Dropdown, NormalizedDropdownItemType } from '@entur/dropdown'
import { VariantType } from '@entur/form'
import { getPossibleCompanies } from '../../api-clients/eba-clients'
import { usePageableApiOnLoad } from '../../api-clients/client-hooks'
import { Company, Employee, FetchState } from '../../api-clients/api-types'
import { ValidationFormField, validateFormField, parseIntOrUndefined } from '../../utils/form-utils'

export const companyFormField = (
  employee?: Employee,
  required = false
): ValidationFormField<number | undefined> => {
  return {
    value: employee?.company.companyId,
    displayValue: employee?.company?.name || '',
    draftValue: employee?.draftEmployee?.company?.name,
    variant: '',
    feedback: '',
    fieldName: 'companyId',
    displayName: 'Selskap',
    validation: {
      required,
    },
  }
}

type DropdownItemType = {
  value: string | undefined
  label: string
}

const companyToDropdownItemType = (company: Company) => {
  return { label: company.name, value: company.companyId.toString() }
}

type CompanyDropdownProps = {
  company: ValidationFormField<number | undefined>
  placeholder: string
  required?: boolean
  update: (value: ValidationFormField<number | undefined>) => void
}
const CompanyDropdown: React.FC<CompanyDropdownProps> = (props) => {
  const [response] = usePageableApiOnLoad<Company>(getPossibleCompanies, {})
  const undefinedLabel: Array<DropdownItemType> = [{ label: props.placeholder, value: undefined }]
  const selectedItem =
    props.company.value !== undefined
      ? {
          label: props.company.displayValue || '',
          value: props.company.value.toString(),
        }
      : null

  const companies =
    response.status === FetchState.SUCCESS
      ? () => {
          const items = [...response.data.items]
            .sort((a: Company, b: Company) => a.name.localeCompare(b.name))
            .map<DropdownItemType>(companyToDropdownItemType)
          return props.required ? items : undefinedLabel.concat(items)
        }
      : undefinedLabel

  const onChange = (e: NormalizedDropdownItemType<string | undefined> | null) => {
    if (e) {
      const newValue = {
        ...props.company,
        value: parseIntOrUndefined(e.value),
        displayValue: e.label,
      }
      console.log(newValue)
      const validatedFormField = validateFormField(newValue) as ValidationFormField<number | undefined>
      props.update(validatedFormField)
    }
  }

  return (
    <Dropdown<string | undefined>
      style={{ cursor: 'pointer' }}
      label={props.company.displayName}
      variant={props.company.variant as VariantType}
      placeholder={props.placeholder}
      feedback={props.company.feedback}
      items={companies}
      selectedItem={selectedItem}
      onChange={onChange}
    />
  )
}

export default CompanyDropdown
